/* eslint-disable max-lines-per-function */
import { DynamischeStundenbewertung } from '@/domain/mitarbeiter/features/anlageassistent/content/Abwesenheiten/DynamischeStundenbewertung/DynamischeStundenbewertung';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { Separator } from '@e2n/ui';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export function Stundenbewertung() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();

  const arbeitstageSelected =
    form.state.values.bezahlung.sollstunden.arbeitstage.length > 0;

  useEffect(() => {
    if (arbeitstageSelected) {
      form.setFieldValue(
        'abwesenheiten.allgemein.stunden',

        form.state.values.bezahlung.sollstunden.tagessoll,
      );
    }
  }, [arbeitstageSelected, form]);

  return (
    <div className="flex flex-col gap-6">
      {arbeitstageSelected && (
        <span className="text-neutrals-900 text-xl font-bold leading-7">
          {t(
            'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.stunden.title',
          )}
        </span>
      )}
      <form.Subscribe
        selector={(state) => ({
          stundenbewertung:
            state.values.abwesenheiten.allgemein.stundenBewertung,
        })}>
        {({ stundenbewertung }) =>
          stundenbewertung === 'fest' || arbeitstageSelected ? (
            <div className="grid md:grid-cols-2">
              <div className="flex flex-col gap-1">
                <form.AppField name="abwesenheiten.allgemein.stunden">
                  {(field) => (
                    <field.HoursInput
                      label={t(
                        'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.stunden.label',
                      )}
                      defaultValue={
                        arbeitstageSelected
                          ? form.state.values.bezahlung.sollstunden.tagessoll
                          : field.state.value
                      }
                      disabled={arbeitstageSelected}
                      isRequired
                      maxHours={24}
                      placeholder="hh:mm"
                      suffix={t(
                        'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.stunden.suffix',
                      )}
                    />
                  )}
                </form.AppField>
                {arbeitstageSelected && (
                  <span className="text-neutrals-700 text-xs font-normal leading-4">
                    {t(
                      'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.stunden.notEditableDescription',
                    )}
                  </span>
                )}
              </div>
            </div>
          ) : stundenbewertung === 'dynamisch' ? (
            <>
              <DynamischeStundenbewertung />
              <Separator />
              <div className="flex flex-col gap-3">
                <span className="text-neutrals-900 text-base font-bold leading-6">
                  {t(
                    'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.berechnungsbeispiel.label',
                  )}
                </span>
                <a
                  href="https://hilfe.e2n.de/bewertung-von-abwesenheiten#dynamische-berechnung"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="flex gap-2 py-2 px-3 items-center text-primary-blue-600 text-sm font-semibold hover:bg-neutrals-200 w-fit rounded-md">
                  <FontAwesomeIcon icon={faArrowRight} className="size-5" />
                  <span>
                    {t(
                      'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.berechnungsbeispiel.link',
                    )}
                  </span>
                </a>
              </div>
            </>
          ) : null
        }
      </form.Subscribe>
    </div>
  );
}
